import { ColorEnum } from '@/constants/color'
import { Layout } from '@/features/layout/types'
import Button from '@/features/ui/buttons/components/Button'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface ShiftCloseoutActionCardProps {
    action: string
    description: string
    layout: Layout
    onPress: () => void
}

const ShiftCloseoutActionCard: FC<ShiftCloseoutActionCardProps> = ({
    action,
    description,
    layout,
    onPress,
}) => {
    const { styles } = useStyles(stylesheet, { layout })

    return (
        <View style={styles.container}>
            <Typography.Description size="large" style={styles.description}>
                {description}
            </Typography.Description>
            <Button color="primary" onPress={onPress} style={styles.action}>
                {action.toUpperCase()}
            </Button>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        width: '100%',
        borderColor: ColorEnum.GRAY_300,
        borderWidth: 1,
        variants: {
            layout: {
                compact: {
                    gap: 24,
                    padding: 12,
                    borderRadius: 16,
                },
                extended: {
                    gap: 32,
                    padding: 16,
                    borderRadius: 12,
                },
            },
        },
    },
    description: {
        variants: {
            layout: {
                compact: {
                    color: ColorEnum.GRAY_900,
                },
                extended: {
                    color: ColorEnum.GRAY_600,
                },
            },
        },
    },
    action: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        variants: {
            layout: {
                compact: {
                    borderRadius: 8,
                },
                extended: {},
            },
        },
    },
})

export default ShiftCloseoutActionCard
